function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   display: flex;\n   justify-content: center;\n   & label {\n      display: block;\n   }\n\n   & form {\n      margin: 2em;\n      min-width: 300px;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { PageLayout } from '../../layout/PageLayout';
import { TfnrLoginForm } from './TfnrLoginForm';
var FormContainer = styled.div(_templateObject());

var TfnrLoginScreen = function TfnrLoginScreen(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title)), /*#__PURE__*/React.createElement(PageLayout, {
    title: "Welcome",
    subtitle: "Login using your SMS/800 Toll-Free Number Registry login ID"
  }, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(TfnrLoginForm, null))));
};

TfnrLoginScreen.defaultProps = {
  title: 'Login'
};
export { TfnrLoginScreen };